module.exports = __webpack_public_path__ + "static/media/swipe-to-reveal-v2.2f4fb2e1.png";